export default __webpack_public_path__ + "static/media/minus.43b3ee24.svg";